<ng-template #popTemplate>
  <nk-company-flag-context-content
    [companyFlagComposite]="companyFlagComposite()"
    [showHeader]="true"
    [showEvidence]="true"
    [showDescription]="true"
    [showDate]="true"></nk-company-flag-context-content>
</ng-template>
<a href="javascript:void(0);" [outsideClick]="true" [popover]="popTemplate" placement="right">
  {{ 'company_flag.' + companyFlagComposite().company_flag_type.company_flag_type_key | translate }}
</a>
